import cn from 'classnames';
import * as React from 'react';

import { CianLogoProps } from './types';

export const CianLogo: React.FC<CianLogoProps> = props => {
  const { isDobroshriftEnabled, link } = props;

  return (
    <div className={cn('c-header-col', 'c-header-left-container')}>
      <a href={link}>
        <span
          className={cn('c-header-logo--new', {
            'c-header-logo--dobroshrift': isDobroshriftEnabled,
          })}
        />
      </a>
    </div>
  );
};

CianLogo.displayName = 'CianLogo';
